import { createContext } from "react";
import { initializeApp } from "firebase/app";
import type { FirebaseApp } from "firebase/app";
import { getMessaging, isSupported, onMessage } from "firebase/messaging";

export const FirebaseContext = createContext<FirebaseApp | undefined>(
  undefined
);

export const firebaseApp = initializeApp({
  apiKey: "AIzaSyAWuxFRPPdG-YcqJQhYNsAFso2wc9qGFIw",
  authDomain: "ava-gap.firebaseapp.com",
  projectId: "ava-gap",
  storageBucket: "ava-gap.appspot.com",
  messagingSenderId: "198293099667",
  appId: "1:198293099667:web:e01a23778f0d26e182e966",
  measurementId: "G-95GLS7F5W1",
});

window.addEventListener("notificationclick", (event) => {
  const notification = (event as any).notification;
  notification.close();

  const data = notification.data;

  let path = "/";
  if (data.type === "chat") {
    path = `/chats/${data.chatId}`;
  } else if (data.type === "news") {
    path = "/notifications";
  } else if (data.type === "match") {
    path = `/matched/${data.userIdSender}`;
  }
  const url = new URL(path, window.location.origin).href;

  (event as any).waitUntil(
    (window as any).clients
      .matchAll({ type: "window", includeUncontrolled: true })
      .then((clientsArr: any) => {
        const hadWindowToFocus = clientsArr.some((windowClient: any) =>
          windowClient.url === url ? (windowClient.focus(), true) : false
        );

        if (!hadWindowToFocus)
          (window as any).clients
            .openWindow(url)
            .then((windowClient: any) =>
              windowClient ? windowClient.focus() : null
            );
      })
  );
});

isSupported().then(() => {
  const messaging = getMessaging(firebaseApp);
  onMessage(messaging, (payload) => {
    console.log("Received foreground message: ", payload);
    if (!payload || !payload.data) return;

    const notificationTitle =
      payload.data.type === "chat"
        ? "پیام جدید از " + payload.data.userNameSender
        : payload.data.title;
    const notificationOptions = {
      body: payload.data.description,
      icon:
        payload.data.avatarId && payload.data.avatarId.length > 0
          ? `https://eu-de-1.asset.avagap.com/${payload.data.avatarId}`
          : "/logo192-any.png",
      data: payload.data,
    };

    navigator.serviceWorker.getRegistration().then(async (reg) => {
      if (!!reg) {
        reg.showNotification(notificationTitle, notificationOptions);
      }
    });
  });
});
